import styled from 'styled-components';
import { Translate } from 'react-redux-i18n';

import { ResourceSelectorTheme } from './index';
import { NewStyleColor } from '../../utils/styles-constants';
import { hexToRgba } from '../../utils/style';

interface ResourceSelectorProps {
	theme: {
		theme: ResourceSelectorTheme;
	};
}

interface ButtonProps {
	iconWidth: string;
	iconHeight: string;
}

const Label = styled(Translate)`
	display: block;
	margin-bottom: 10px;
	padding-left: 10px;
	font-family: HelveticaNeue, sans-serif;
	font-size: 13px;
	line-height: 20px;
	color: ${NewStyleColor.Black};
	text-transform: uppercase;
	letter-spacing: 1px;

	${({ theme: { theme } }: ResourceSelectorProps) => theme === ResourceSelectorTheme.DARK && `
		color: ${hexToRgba(NewStyleColor.White, 75)};
	`}
`;

const Button = styled('button')`
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	height: 44px;
	padding: 0 15px;
	border-radius: 8px;
	border: 0;
	outline: 0;
	font-family: HelveticaNeue, sans-serif;
	font-size: 17px;
	line-height: 44px;
	color: ${hexToRgba(NewStyleColor.Black, 80)};
	background-color: ${NewStyleColor.White};
	cursor: pointer;

	&:hover {
		background-color: ${hexToRgba(NewStyleColor.Black, 13)};
	}

	&:active {
		background-color: ${hexToRgba(NewStyleColor.Black, 20)};
	}

	${({ theme: { theme } }: ResourceSelectorProps) => theme === ResourceSelectorTheme.DARK && `
		background-color: ${hexToRgba(NewStyleColor.White, 10)};
		color: ${hexToRgba(NewStyleColor.White, 75)};

		&:hover {
			background-color: ${hexToRgba(NewStyleColor.White, 25)};
		}

		&:active {
			background-color: ${hexToRgba(NewStyleColor.White, 30)};
		}
	`}

	svg {
		width: ${({ iconWidth }: ButtonProps) => iconWidth};
		height: ${({ iconHeight }: ButtonProps) => iconHeight};
		fill: ${({ theme: { theme } }: ResourceSelectorProps) => theme === ResourceSelectorTheme.DARK ? 'currentColor' : hexToRgba(NewStyleColor.Black, 60)};
	}
`;

const ButtonsList = styled('ul')`
	margin: 0;
	padding: 0;
	list-style-type: none;

	li:not(:last-child) {
		margin-bottom: 12px;
	}
`;

const ResourceType = styled('span')`
	display: block;
	margin-top: 8px;
	padding-left: 10px;
	font-family: HelveticaNeue, sans-serif;
	font-size: 11px;
	line-height: 16px;
	color: ${hexToRgba(NewStyleColor.Black, 55)};
	text-transform: uppercase;

	span {
		text-transform: none;
	}

	${({ theme: { theme } }: ResourceSelectorProps) => theme === ResourceSelectorTheme.DARK && `
		color: ${hexToRgba(NewStyleColor.White, 75)};
	`}
`;

export {
	Label,
	Button,
	ButtonsList,
	ResourceType,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ResourceSelector/styles.ts